import './styles.scss';
import classNames from 'classnames';
import { useContext, useEffect } from 'react';
import { GlobalContext } from 'Context/GlobalContext/AppContext';

const ResponseMsg = () => {
  const { responseMsg, setResponseMsg } = useContext(GlobalContext);

  useEffect(() => {
    if (responseMsg.isVisible) {
      setTimeout(() => {
        setResponseMsg((prevState) => ({ ...prevState, isVisible: false, error: false }));
      }, 3500);
    }
  }, [setResponseMsg, responseMsg.isVisible]);

  const responseMsgClass = classNames({
    responseMsg: true,
    'responseMsg--error': responseMsg.error,
    'responseMsg--visible': responseMsg.isVisible,
  });

  return <div className={responseMsgClass}>{responseMsg.msg}</div>;
};

export default ResponseMsg;
